import { TestId } from './utils';

export type LoaderProps = {
	/** The `isLoading` prop determines whether to render the Loader or it's children */
	isLoading: boolean;
	/** The `message` prop determines what if any text should be rendered with the loader */
	message?: string;
	/** The `size` prop determines how large of a Loader should be rendered */
	size?: LoaderSizes;
} & TestId;
export enum LoaderSizes {
	small = 'small',
	medium = 'medium',
	large = 'large',
}
